import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Subject, Subscription, debounceTime, firstValueFrom, of } from 'rxjs';
import { UserService } from '../../../../../../core/services/user.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { DynamicModalService } from '../../../../../../core/services/dynamic-modal.service';
import {
  selectAuth,
  selectUser,
} from '../../../../../../core/state/auth/auth.selector';
import { Store } from '@ngrx/store';
import { CodeBonusService } from '../../../../../../core/services/code-bonus.service';
import { PlayerService } from '../../../../../../core/services/player.service';
import { CODE_BONUS_CONSTANS } from '../../../../../../core/constants/constants';

@Component({
  selector: 'app-create-forms-bc',
  templateUrl: './create-forms-bc.component.html',
  styleUrls: ['./create-forms-bc.component.scss'],
})
export class CreateFormsBcComponent implements OnInit {
  public optionsBonusTypes$: any;
  public bonoIlimitado$ = this.store.select(selectUser);
  public allTypeBonusData: any[] = [];
  public optionsAgents$: any;
  public optionsPlayers$: any;
  public id_country!: any;
  public agente = CODE_BONUS_CONSTANS.AGENTE;
  public pagos = CODE_BONUS_CONSTANS.PAGOS;
  public atc = CODE_BONUS_CONSTANS.ATC;
  public administrador = CODE_BONUS_CONSTANS.ADMINISTRADOR;
  public afiliados = CODE_BONUS_CONSTANS.AFILIADO;
  public currentPageAgents = 1;
  public currentPagePlayers = 1;
  public bonoIlimitado: number | null = null;
  public allPlayersData: any[] = [];
  public allAgentsData: any[] = [];
  public isAgent = true;
  public pageSize = 10;
  private bonusSubject: Subject<string> = new Subject<string>();
  public criteria: any;
  public bonusForm!: FormGroup;
  public isLoadingButton = false;
  public isLoadingBonusTypes = false;
  public profile$ = this.store.select(selectAuth);
  public profile: any;
  public idRol: number | null = null;
  private selectedOption: any = null;
  private id_agente: any = null;
  private currentUserId: number | null = null;
  private agenteBalance: any = null;
  public bonusBalanceData: number = 0;
  private subscriptions: Subscription[] = [];
  public codeBonus$ = this.store.select(selectUser);

  private buildBonusTypeLabel(item: any): string {
    const baseLabel = item.nombre || item.detalle;
    if (this.idRol === this.agente) {
      return baseLabel;
    }

    return `${baseLabel} - ${item.porcentaje}%`;
  }

  constructor(
    private _userService: UserService,
    private bonusCodeService: CodeBonusService,
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
    private _toastrSvc: ToastrService,
    private dynamicModal: DynamicModalService,
    private store: Store,
    private cd: ChangeDetectorRef,
    private _playerService: PlayerService
  ) {
    this.initForm();
    this.bonusSubject
      .pipe(
        debounceTime(400) // Adjust debounce time as needed (e.g., 300 milliseconds)
      )
      .subscribe((term: any) => {
        this.getBalanceBonus();
        this.allAgentsData = [];
        this.allPlayersData = [];
        if (this.isAgent) {
          this.loadAgents(term);
        } else {
          this.loadPlayers(term);
        }
      });
    this.isLoadingButton = false;
  }
  async ngOnInit(): Promise<void> {
    const data = this.dynamicModal.getModalData();
    const profileData: any = await firstValueFrom(this.bonoIlimitado$);
    this.id_country = this.dynamicModal.getModalData();
    this.currentUserId = profileData?.idusuario ?? null;
    this.cd.detectChanges();
    this.loadPlayers();
    if (data.id_agente) {
      this.idRol = data.idRol;
      this.bonoIlimitado = data.bonoIlimitado;
      this.id_agente = data.id_agente;
      this.id_country = data.id_country;
    } else {
      this.idRol = profileData.id_rol;
      this.bonoIlimitado = profileData.bono_ilimitado;
      this.id_agente = profileData.idusuario;
    }
    if (this.idRol === this.agente) {
      this.bonusForm.patchValue({ id_agente: this.id_agente });
      this.bonusForm.get('id_agente')?.clearValidators();
      this.handleAgentSelection(this.id_agente);
    } else {
      this.bonusForm.get('id_agente')?.setValidators(Validators.required);
      this.loadAgents();
    }
    this.bonusForm.get('id_agente')?.updateValueAndValidity();
    this.subscribeToAgentChanges();
  }

  loadAgents(searchTerm?: string) {
    this._userService
      .getAgents(
        this.id_country,
        this.currentPageAgents,
        this.pageSize,
        searchTerm
      )
      .subscribe((response) => {
        const transformedData = response.data.map(
          (item: { usuario: any; idusuario: any }) => {
            return { label: item.usuario, value: item.idusuario };
          }
        );
        this.optionsAgents$ = of(transformedData);
        this.allAgentsData = [...this.allAgentsData, ...transformedData];
      });
  }

  subscribeToAgentChanges() {
    const subscription = this.bonusForm
      .get('id_agente')
      ?.valueChanges.subscribe((agentId) => {
        if (this.idRol === this.agente) {
          return;
        }
        this.handleAgentSelection(agentId);
      });

    if (subscription) {
      this.subscriptions.push(subscription);
    }
  }

  handleAgentSelection(agentId: number | null) {
    this.id_agente = agentId;
    this.resetBonusTypeSelection();

    if (!agentId) {
      this.bonusBalanceData = 0;
      return;
    }

    this.loadTypeBonusByAgent(agentId);
    this.getBalanceBonus(agentId);
  }

  loadTypeBonusByAgent(agentId: number) {
    this.isLoadingBonusTypes = true;

    const subscription = this.bonusCodeService
      .getAssignedTypeBonusByAgent(agentId)
      .subscribe({
        next: (response) => {
          const filteredData = (response.data || []).filter(
            (item: any) => item.activar === 1,
          );

          this.allTypeBonusData = filteredData.map((item: any) => {
            return {
              label: this.buildBonusTypeLabel(item),
              value: item.idbono_tipos,
              porcentaje: item.porcentaje,
              detalle: item.detalle,
              nombre: item.nombre,
            };
          });

          if (this.allTypeBonusData.length > 0) {
            this.bonusForm.patchValue({
              tipo_bono: null,
              detalle_tipo_bono: null,
            });
            this.selectedOption = null;
          } else {
            this._toastrSvc.info(
              'El agente seleccionado no tiene tipos de bono asignados',
              '',
              {
                positionClass: 'custom-toastr-top',
              }
            );
          }

          this.isLoadingBonusTypes = false;
        },
        error: () => {
          this.isLoadingBonusTypes = false;
          this._toastrSvc.error('No se pudieron cargar los tipos de bono', '');
        },
      });

    this.subscriptions.push(subscription);
  }

  resetBonusTypeSelection() {
    this.allTypeBonusData = [];
    this.selectedOption = null;
    this.bonusForm.patchValue({
      tipo_bono: null,
      detalle_tipo_bono: null,
      monto_recarga: null,
      monto: null,
      fracciones: 1,
    });
  }

  private syncSelectedOptionFromControl() {
    const selectedBonusTypeId = Number(this.bonusForm.get('tipo_bono')?.value);

    if (!selectedBonusTypeId) {
      this.selectedOption = null;
      return;
    }

    this.selectedOption =
      this.allTypeBonusData.find(
        (option) => Number(option.value) === selectedBonusTypeId
      ) ?? null;
  }

  onSelectChange(selectedValue: any) {
    const bonusTypeId = Number(selectedValue?.value ?? selectedValue ?? this.bonusForm.get('tipo_bono')?.value);

    if (!bonusTypeId) {
      this.selectedOption = null;
      this.bonusForm.patchValue({ monto: null });
      return;
    }

    this.selectedOption = this.allTypeBonusData.find(
      (option) => Number(option.value) === bonusTypeId
    );

    if (this.selectedOption) {
      this.calculateResultAmountBonus();
    }
  }

  onRechargeAmountChange(event: any) {
    this.calculateResultAmountBonus();
  }
  calculateResultAmountBonus() {
    const rechargeAmount = this.bonusForm.get('monto_recarga')?.value;
    const fractions = this.bonusForm.get('fracciones')?.value || 1;

    if (!this.selectedOption) {
      this.syncSelectedOptionFromControl();
    }

    if (this.selectedOption && rechargeAmount) {
      const multiplyingPercentage =
        parseFloat(this.selectedOption.porcentaje) * parseFloat(rechargeAmount);
      const amountPerBonus = multiplyingPercentage / parseFloat(fractions);
      this.bonusForm.patchValue({ monto: amountPerBonus.toFixed(2) });
    }
  }

  loadPlayers(searchTerm?: string) {
    this._playerService
      .getPlayers(
        this.id_country,
        this.currentPagePlayers,
        this.pageSize,
        searchTerm
      )
      .subscribe((response) => {
        const transformedData = response.data.map((item: any) => {
          return {
            label: item.usuario_jugador,
            value: item.id_jugador,
            whiteList: item.jugador_white_list?.lista_negra,
            id_usuario: item.id_usuario,
          };
        });
        this.optionsPlayers$ = of(transformedData);
        this.allPlayersData = [...this.allPlayersData, ...transformedData];
      });
  }
  //*NG-SELECT
  onScrollToEnd() {
    if (this.isAgent) {
      this.currentPageAgents++;
      this.loadAgents(this.criteria);
    } else {
      this.currentPagePlayers++;
      this.loadPlayers(this.criteria);
    }
  }
  onSearch(term: string) {
    this.criteria = term;
    if (this.isAgent) {
      this.allAgentsData = [];
      this.currentPageAgents = 1;
      this.bonusSubject.next(term);
    } else {
      this.allPlayersData = [];
      this.currentPagePlayers = 1;
      this.bonusSubject.next(term);
    }
  }
  toggleUserType() {
    this.isAgent = !this.isAgent;
    this.criteria = '';
    if (this.isAgent) {
      this.loadAgents();
    } else {
      this.loadPlayers();
    }
  }

  //?MODAL
  closeModal() {
    this.activeModal.close();
    this.bonusForm.reset();
  }
  //*FORM
  initForm(): void {
    this.bonusForm = this.fb.group({
      monto_recarga: [null],
      monto: [null, Validators.min(0.1)],
      tipo_bono: [null, Validators.required],
      id_agente: [null],
      comentario: [null],
      fracciones: [1],
      id_usu_creabono: [null],
      detalle_tipo_bono: [null],
      id_pais: [null],
    });
  }
  onKeyPressSpecial(event: KeyboardEvent) {
    const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'];
    if (!allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  isFormValid(): boolean {
    if (this.idRol === this.agente) {
      return (
        this.bonusForm.valid && this.bonusForm.get('fracciones')?.value > 0
      );
    } else {
      return (
        this.bonusForm.valid && this.bonusForm.get('fracciones')?.value > 0
      );
    }
  }

  getBalanceBonus(agentId?: number): void {
    const targetAgentId = agentId ?? this.id_agente;

    if (!targetAgentId) {
      this.bonusBalanceData = 0;
      return;
    }

    const subscription = this.bonusCodeService
      .getAgentBalance({ agentId: targetAgentId })
      .subscribe({
        next: (response) => {
          this.bonusBalanceData = response.data.bonusBalance;
        },
        error: (error) => {
          this._toastrSvc.error('Internal server error', 'Error');
        },
      });
    this.subscriptions.push(subscription);
  }

  canConfigureBonus(): boolean {
    return !!this.id_agente && this.allTypeBonusData.length > 0;
  }

  hasNoAvailableBonusTypes(): boolean {
    return !!this.id_agente && !this.isLoadingBonusTypes && this.allTypeBonusData.length === 0;
  }

  shouldShowTopAlert(): boolean {
    if (this.idRol === this.agente) {
      return this.hasNoAvailableBonusTypes();
    }

    return !this.canConfigureBonus();
  }

  getTopAlertMessage(): string {
    if (this.idRol === this.agente) {
      return 'No tienes bonos disponibles. Contacta al administrador para soporte de bonos.';
    }

    if (!this.id_agente) {
      return 'Primero selecciona un agente para cargar sus bonos asignados.';
    }

    if (this.hasNoAvailableBonusTypes()) {
      return 'El agente seleccionado no tiene ningun bono configurado.';
    }

    return 'Primero selecciona un agente para cargar sus bonos asignados.';
  }

  getTopAlertClass(): string {
    if (!this.id_agente && this.idRol !== this.agente) {
      return 'alert alert-info';
    }

    return 'alert alert-warning';
  }

  getBonusTypePlaceholder(): string {
    if (this.hasNoAvailableBonusTypes()) {
      return 'No hay bonos disponibles. Contacta al administrador para soporte de bonos.';
    }

    return 'Seleccione una opción';
  }

  sendFormData() {
    this.isLoadingButton = true;
    if (this.idRol === this.agente) {
      this.bonusForm.patchValue({ id_agente: this.id_agente });
    }

    this.bonusForm.patchValue({
      id_usu_creabono: this.currentUserId,
      detalle_tipo_bono: this.selectedOption?.detalle,
      tipo_bono: this.selectedOption?.nombre,
      id_pais: this.id_country,
    });

    const formData = this.bonusForm.value;
    formData.id_tipo_bono = this.selectedOption?.value;
    const fractions = formData.fracciones;
    const totalAmount =
      parseFloat(this.bonusForm.get('monto')?.value || '0') * fractions;

    if (this.idRol === this.agente && totalAmount > this.bonusBalanceData) {
      this.isLoadingButton = false;
      this._toastrSvc.error(
        'Saldo insuficiente para crear los bonos, Recargue',
        'Error'
      );
      return;
    }

    this._toastrSvc.info('Procesando... ⌛', '', {
      timeOut: 500,
    });

    const request = {
      data: formData,
      fracciones: fractions,
    };

    this.bonusCodeService.createCodeBonus(request).subscribe(
      (response) => {
        this.isLoadingButton = false;
        this._toastrSvc.success('Bonos creados con éxito!', '');
        this.dynamicModal.notifyBonusCreated();
        this.closeModal();
      },
      (err) => {
        this.isLoadingButton = false;
        this._toastrSvc.error('Error al crear los bonos', '');
        console.error('Error:', err);
      }
    );
  }

  onInputChange(event: any) {
    let value = Math.round(event.target.value);
    if (value < 0) {
      value = 0;
    }
    event.target.value = value;
    this.bonusForm.patchValue({ fracciones: value });
    this.calculateResultAmountBonus();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
